import * as React from 'react';
import { Query, QueryProps } from 'react-apollo';
import { FirebaseAuthProvider } from '.';

function getRequestContext(
  token: string | null
): Record<string, any> | undefined {
  if (!token) {
    return undefined;
  }
  return {
    headers: {
      authorization: token
    }
  };
}

const AuthorizedQuery = (props: QueryProps) => (
  <FirebaseAuthProvider>
    {(user, token) => (
      <Query
        {...props}
        skip={!token || props.skip}
        context={getRequestContext(token)}
      />
    )}
  </FirebaseAuthProvider>
);

export default AuthorizedQuery;



// WEBPACK FOOTER //
// ./src/providers/AuthorizedQuery.tsx